var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lots-list tab-table p-2"},[_c('relations-table',{attrs:{"hide-action-buttons":true,"exclude-columns":['created_at', 'created_by',
  'updated_at', 'updated_by', 'intermediary_commission_from', 'related_customer_uuid'],"exclude-search-fields":['related_customer_uuid']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }